<template>
  <div class="product-stock">
    <h3 class="headline">{{$t('stock')}}</h3>
    <template v-if="productstock.length > 0">
      <product-stock-item
        v-for="(stock,index) in productstock"
        :key="'stock_'+ index"
        :stockkey="index"
        :products="products"
        :productskey="productskey"
        :productstock="productstock"
        :index="index"
        v-model="productstock[index]"
        :max="productstock.length"
        @onDelete="deleteProductStock(index,stock[0])"
        @onMove="onMove(index,$event)"
      ></product-stock-item>
    </template>
    <div
      v-if="duplicate.length"
      style="color:red;margin-bottom: 1.5em"
    >Keyword {{duplicate.join(',')}} ถูกใช้ไปแล้ว</div>
    <a
      href="javascript:void(0);"
      class="btn-add text-xs-center"
      @click="addProductStock"
      style="margin-bottom: 15px;padding: 15px 0; text-decoration: none"
    >
      <span class="fa fa-plus"></span>
      {{$t('add new stock')}}
    </a>
  </div>
</template>

<script>
import ProductStockItem from './ProductStockItem'

export default {
  props: ['value', 'duplicate', 'products', 'productskey'],
  inject: ['parentValidator'],
  data: function() {
    return {
      productstock: this.value,
      newProductStock: {
        option: null,
        quantity: 0
      },
      min: 0,
      max: 999,
      isAdd: false,
      deletelist: []
    }
  },
  mounted: function() {
    if (this.productstock.length == 0) {
      this.addProductStock()
    }
  },
  created() {
    this.$validator = this.parentValidator
  },
  components: {
    ProductStockItem
  },
  computed: {},
  methods: {
    sortProductStock: function() {
      this.productstock = this.productstock.sort(function(a, b) {
        if (a[6] > b[6]) {
          return 1
        } else if (a[6] < b[6]) {
          return -1
        } else {
          return 0
        }
      })
    },
    addProductStock: function() {
      let vm = this
      vm.productstock.push([null, null, null, null, null, null, null])
    },
    deleteProductStock: function(index, id) {
      let vm = this

      if (vm.productstock.length <= 1) {
        vm.$swal.fire({
          title: vm.$t('The stock must have at least 1 item'),
          type: 'warning',
          confirmButtonText: vm.$t('Confirm'),
          reverseButtons: true
        })
        return false
      }
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: (vm.productstock[index][1] ? vm.productstock[index][1] : '').replace(/\<|\>/g, '')
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            if (id != null) {
              vm.deletelist.push(id)
              vm.$emit('deleteStock', id)
            }
            vm.productstock.splice(index, 1)
          }
        })
    },
    onMove: function(index, direction) {
      var vm = this
      if (direction == 'up') {
        vm.$set(vm.productstock[index], 6, index - 1)
        vm.$set(vm.productstock[index - 1], 6, index)
      } else if (direction == 'down') {
        vm.$set(vm.productstock[index], 6, index + 1)
        vm.$set(vm.productstock[index + 1], 6, index)
      }
      vm.sortProductStock()
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.productstock = this.value
      // if (this.productstock.length > 0) {
      //   for (let index = 0; index < this.productstock.length; index++) {
      //     console.log('STOCK LENGTH:', this.productstock.length)
      //     this.productstock[index][6] = index
      //   }
      // }
    },
    productstock: function() {
      this.$emit('input', this.productstock)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/view/live/ProductStock.vue